export const onMobile = () => window.innerWidth < 1100;
